import { useEffect, useContext } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import './App.css';
import AuthModal from './components/AuthModal';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import CookieConsent from "react-cookie-consent";
import GymOwnerDashboard from './pages/GymOwnerDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard.jsx';
import CustomerDashboard from './pages/CustomerDashboard';
import LandingPage from './pages/LandingPage.jsx';
import BookDemo from './pages/BookDemo.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

// Admin Portal Imports
import AdminGuard from './components/AdminGuard';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/AdminLogin';
import AdminOverview from './pages/AdminOverview';
import GymList from './pages/GymList';
import GymForm from './pages/GymForm';
import GymDetail from './pages/GymDetail';
import AdCampaigns from './pages/AdCampaigns';
import AdForm from './pages/AdForm';
import Analytics from './pages/Analytics';
import Devices from './pages/Devices';
import Users from './pages/Users';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import Bookings from './pages/Bookings';
import AdminRewards from './pages/AdminRewards';
import AdminStore from './pages/AdminStore';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loading } = useContext(AuthContext);

  useEffect(() => {
    if (loading) return;

    const params = new URLSearchParams(location.search);
    const otp = params.get("otp");
    const email = params.get("email");

    if (otp && email && location.pathname !== '/auth') {
      navigate(`/auth?otp=${otp}&email=${email}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate, loading]);

  if (loading) {
    return <div className="flex justify-center items-center h-screen bg-[#101010]">Loading...</div>;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/book-demo" element={<BookDemo />} />

        {/* ✅ ADD requiredRole FOR EACH DASHBOARD */}
        <Route
          path="/customerdashboard"
          element={<ProtectedRoute requiredRole="User"><CustomerDashboard /></ProtectedRoute>}
        />
        <Route
          path="/member/feed"
          element={<ProtectedRoute requiredRole="User"><CustomerDashboard initialTab="gymfeed" /></ProtectedRoute>}
        />
        <Route
          path="/member/store"
          element={<ProtectedRoute requiredRole="User"><CustomerDashboard initialTab="store" /></ProtectedRoute>}
        />
        <Route
          path="/member/membership"
          element={<ProtectedRoute requiredRole="User"><CustomerDashboard initialTab="profile" /></ProtectedRoute>}
        />
        <Route
          path="/edashboard"
          element={<ProtectedRoute requiredRole="Trainer"><EmployeeDashboard /></ProtectedRoute>}
        />
        <Route
          path="/Odashboard"
          element={<ProtectedRoute requiredRole="Owner"><GymOwnerDashboard /></ProtectedRoute>}
        />
        <Route
          path="/owner/reports"
          element={<ProtectedRoute requiredRole="Owner"><GymOwnerDashboard initialTab="Reports" /></ProtectedRoute>}
        />

        <Route path="/auth" element={<AuthModal />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* ✅ SUPER ADMIN PORTAL ROUTING */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
          <Route index element={<AdminOverview />} />
          <Route path="gyms" element={<GymList />} />
          <Route path="gyms/new" element={<GymForm />} />
          <Route path="gyms/:id" element={<GymDetail />} />
          <Route path="rewards" element={<AdminRewards />} />
          <Route path="store" element={<AdminStore />} />
          <Route path="ads" element={<AdCampaigns />} />
          <Route path="ads/new" element={<AdForm />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="devices" element={<Devices />} />
          <Route path="users" element={<Users />} />
          <Route path="billing" element={<Billing />} />
          <Route path="settings" element={<Settings />} />
          <Route path="reports" element={<Reports />} />
          <Route path="bookings" element={<Bookings />} />
        </Route>
      </Routes>

      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        cookieName="fitscanCookieConsent"
        style={{ background: "#181f10", color: "#d1fae5", fontSize: "14px" }}
        buttonStyle={{ backgroundColor: "#84cc16", color: "#181f10", fontWeight: "bold", borderRadius: "9999px", padding: "8px 16px" }}
        declineButtonStyle={{ backgroundColor: "#dc2626", color: "white", fontWeight: "bold", borderRadius: "9999px", padding: "8px 16px" }}
        onAccept={() => { }}
      />
    </>
  );
}

export default App;
